import { useEffect, useState } from 'react';
import { authApi } from './resources';

/**
 * Mode de connexion en vigueur, lu une fois auprès du serveur.
 *
 * Tant que le code à six chiffres n'est pas obligatoire pour tous, l'ouvrier
 * entre encore par « Code ouvrier » et chacun choisit d'activer le code pour
 * son compte. Le serveur seul le sait : l'écran le lui demande.
 */

let enCache = null;
let enCours = null;

/**
 * @returns {Promise<{codeObligatoire: boolean, codeOuvrier: boolean, sms: boolean} | null>}
 *   le mode, ou null s'il n'a pas pu être lu
 */
export function chargeModeConnexion() {
  if (enCache) return Promise.resolve(enCache);
  if (!enCours) {
    enCours = Promise.resolve()
      .then(() => authApi.modeConnexion())
      .then((mode) => {
        enCache = mode && typeof mode === 'object' ? mode : null;
        return enCache;
      })
      .catch(() => null)
      .finally(() => {
        enCours = null;
      });
  }
  return enCours;
}

/** Oublie le mode lu, pour les tests. */
export function oublieModeConnexion() {
  enCache = null;
  enCours = null;
}

/**
 * @returns {{codeObligatoire: boolean, codeOuvrier: boolean, sms: boolean} | null}
 *   le mode en vigueur, null tant qu'il n'est pas lu
 */
export function useModeConnexion() {
  const [mode, setMode] = useState(enCache);
  useEffect(() => {
    if (enCache) return undefined;
    let vivant = true;
    chargeModeConnexion().then((lu) => {
      if (vivant && lu) setMode(lu);
    });
    return () => {
      vivant = false;
    };
  }, []);
  return mode;
}
